import React, { Fragment } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import UpIcon from "@mui/icons-material/ArrowUpward";
import DownIcon from "@mui/icons-material/ArrowDownward";
import BottomIcon from "@mui/icons-material/VerticalAlignBottom";
import TopIcon from "@mui/icons-material/VerticalAlignTop";

const ShowcaseItemActions = ({ onUp, onDown, onTop, onBottom, onDelete }) => {
  return (
    <Fragment>
      <IconButton aria-label="top" onClick={onTop} size="large">
        <TopIcon />
      </IconButton>
      <IconButton aria-label="up" onClick={onUp} size="large">
        <UpIcon />
      </IconButton>
      <IconButton aria-label="down" onClick={onDown} size="large">
        <DownIcon />
      </IconButton>
      <IconButton aria-label="bottom" onClick={onBottom} size="large">
        <BottomIcon />
      </IconButton>
      <IconButton aria-label="delete" onClick={onDelete} size="large">
        <DeleteIcon />
      </IconButton>
    </Fragment>
  );
};

export default ShowcaseItemActions;
